import React from "react";
import AppSidebar from "./appsidebar/AppSidebar";
import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";

function Layout(props) {
  return (
    <div style={{ display: "flex", width: "100%" }}>
      <AppSidebar />
      <Outlet />
    </div>
  );
}

export default Layout;
